export default __webpack_public_path__ + "static/media/5.0163d723.jpg";